import type React from 'react';

import ReactMarkdown, { type Options } from 'react-markdown';

import designsystemtypography from '@helsenorge/designsystem-react/scss/typography.module.scss';
type Props = { href: string | undefined; children: React.ReactNode; ariaLabel?: string };

export const ExternalLinkRenderer = ({ href, children, ariaLabel }: Props): React.JSX.Element => {
  return (
    <a href={href} aria-label={ariaLabel} target="_blank" rel="noopener noreferrer">
      {children}
    </a>
  );
};

export const MarkdownContent = (props: Options): React.JSX.Element => {
  const classes = `${designsystemtypography['anchorlink-wrapper']} verktoy__markdown`.trim();
  return (
    <div className={classes}>
      <ReactMarkdown {...props} />
    </div>
  );
};
